import { createSlice } from '@reduxjs/toolkit';
const fromLocalStore = localStorage.getItem("rea-alerts-dismissed");
const stored = JSON.parse(fromLocalStore !== null && fromLocalStore !== void 0 ? fromLocalStore : "[]");
const initialState = {
    dismissed: stored !== null && stored !== void 0 ? stored : [],
};
export const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        dismiss: (state, action) => {
            state.dismissed = [...state.dismissed, action.payload];
        }
    },
});
export const { dismiss } = alertSlice.actions;
export default alertSlice.reducer;
